import { render, staticRenderFns } from "./horizontal-nav.vue?vue&type=template&id=39854a12&scoped=true&"
import script from "./horizontal-nav.vue?vue&type=script&lang=js&"
export * from "./horizontal-nav.vue?vue&type=script&lang=js&"
import style0 from "./horizontal-nav.vue?vue&type=style&index=0&id=39854a12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39854a12",
  null
  
)

export default component.exports